import * as React from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { animated } from 'react-spring';

import { Container } from '../../../layout/Container';

import { Heading } from '../../../ui/text/Heading';
import { Paragraph } from '../../../ui/text/Paragraph';

import { useFadeTransition } from '../../../../utils/hooks/useFadeTransition';
import { Seo } from '../../../../utils/seo/Index';

import { BaseHeroContent, Hero } from '../../../ui/hero/Index';

const Dobbeltboligforsikring: React.FC = () => {
  const location = useLocation();

  const { fadeIn: pageFadeIn } = useFadeTransition({
    immidiate: true
  });

  return (
    <>
      <Seo
        title="Dobbelt eiendomsforsikring - PrivatMegleren"
        description="Gi kjøperen din garanti mot doble boutgifter i forbindelse med eiendommsskjøp"
        url={location.pathname}
      />
      <Hero
        imageUrl="https://cdn.reeltime.no/pm_assets/content/tilrettelagt_boligsalg.jpeg"
        opacity={0.4}
        height="500px"
        className="top-header-margin"
        alt="bilde"
      >
        <HeroContent style={pageFadeIn}>
          <Heading tag="h1" center>
            Dobbelt eiendomsforsikring
          </Heading>
          <Paragraph center>
            Gi kjøperen din garanti mot doble boutgifter i forbindelse med
            eiendomskjøp
          </Paragraph>
        </HeroContent>
      </Hero>
      <Container style={{ ...pageFadeIn, paddingTop: '40px' }}>
        <Paragraph center>
          Om man kjøper før man selv selger, risikerer man å bli sittende med to
          eiendommer i en periode. Man kan også ende opp med å kjøpe og selge i
          to ulike markeder, noe som er med på å skape usikkerhet hos
          potensielle kjøpere.
        </Paragraph>
        <Paragraph center>
          Dobbelteiendomsforsikring gir kjøper en garanti mot doble bo-utgifter
          dersom det tar tid å selge nåværende eiendom.
        </Paragraph>
        <Paragraph center>
          <b>
            Eiendommer som selges med dobbelteiendomsforsikring fremstår mer
            attraktive for usikre kjøpere, og det vil føles tryggere å legge inn
            bud.
          </b>
        </Paragraph>
        <Paragraph center>
          Dobbelteiendomsforsikringen dekker kjøpers ekstra eiendomskostnader
          med inntil kr 15 000 per måned i inntil 9 måneder dersom kjøper ikke
          får solgt sin nåværende eiendom før overtakelse av ny eiendom.
        </Paragraph>
        <Paragraph center>
          Dette omfatter netto rentekostnader og faktiske ekstra
          eiendomskostnader ved usolgt eiendom (felleskostnader,
          eiendomsforsikring, oppvarming/strøm og kommunale avgifter).
        </Paragraph>
        <Grid>
          <div className="col center">
            <Heading tag="h2" center>
              Pris 6 500,-
            </Heading>
            <Paragraph center>
              Forsikringen har samme pris uansett eiendomstype. Den tegnes og
              betales av selger, og det er kjøper som vil få utbetaling fra
              forsikringen. Forsikringen bestilles av eiendomsmegler.
            </Paragraph>
            <Paragraph center>
              <b>Dekker ekstra boutgifter for kjøper inntil 9 måneder.</b>
            </Paragraph>
            <img
              alt="bilde av logo"
              src="https://cdn.reeltime.no/pm_assets/content/sp-eiendom-logo-large_2.jpeg"
            />
            <Paragraph center>
              Forsikringen administreres av Sodeberg & Partners og forsikringen
              er plassert hos forsikringsselskapet HDI Global Specialty SE.
              Skadebehandlingsselskapet er Claims Link. Fomidlingsprovisjon til
              eiendomsmegler utgjør kr 1 000.
            </Paragraph>
          </div>
          <div className="col">
            <Heading tag="h2" center>
              Tryggere eiendomshandel
            </Heading>
            <Paragraph center>
              Forsikringen er gyldig i 12 mnd etter overtakelse av ny eiendom.
            </Paragraph>
            <Paragraph center>
              Den gir utbetaling når kjøper oppfyller følgende to krav
            </Paragraph>
            <Paragraph center>1. Overtatt ny eiendom.</Paragraph>
            <Paragraph center>
              2. Forsøkt å selge eksisterende eiendom gjennom eiendomsmegler i
              minst tre måneder.
            </Paragraph>
          </div>
        </Grid>
        <VideoLink href="https://vimeo.com/417099924/6035a55db5">
          Se vår presentasjonsvideo
        </VideoLink>
      </Container>
    </>
  );
};

export default Dobbeltboligforsikring;

const HeroContent = styled(animated.div)`
  ${BaseHeroContent}
  flex-flow: column;
  max-width: 700px;
`;

const Grid = styled.div`
  margin-top: 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;

  .col {
    padding: 0 20px;

    &.center {
      display: grid;
      justify-content: center;
    }

    img {
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
    }
  }

  @media all and (max-width: 960px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
`;

const VideoLink = styled.a`
  margin-top: 30px;
  display: block;
  text-align: center;
  padding: 20px;
`;
